import { useCallback } from 'react'

import useCommonWindowLocation from 'common/hooks/useWindowLocation'
import { page } from 'artkive/utils/tracker'

export default function useWindowLocation() {
  const handlePageChange = useCallback(() => page(), [])
  return useCommonWindowLocation({ onPageChange: handlePageChange })
}
